import React from 'react';
import {
  RouteComponentProps,
  withRouter,
  matchPath,
  generatePath,
} from 'react-router';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useQuestionnaireReponse } from '../../../contexts/questionnaireResponse';

const EditQuestionnaireResponseButton = (props: RouteComponentProps) => {
  const pathTemplate =
    '/organization/:organizationId/patient/:patientId/questionnaireResponse/:questionnaireResponseId/edit';
  const match = matchPath<{
    organizationId: string;
    patientId: string;
  }>(props.location.pathname, {
    path: '/organization/:organizationId/patient/:patientId',
  });
  const questionnaireResponse = useQuestionnaireReponse();
  const patientId = match && match.params.patientId;
  const questionnaireResponseId =
    questionnaireResponse.questionnaireResponse &&
    questionnaireResponse.questionnaireResponse.id;
  if (!match || !patientId || !questionnaireResponseId) return null;
  const params = { ...match.params, questionnaireResponseId };
  const path = generatePath(pathTemplate, params);
  return (
    <Button
      tag={Link}
      to={path}
      className={'float-right d-print-none'}
      color="success">
      Edit
    </Button>
  );
};
export default withRouter(EditQuestionnaireResponseButton);
